import { useInfiniteQuery } from '@tanstack/react-query';
import { ProductsApi } from '@up2stay/up2promo-api-client';

import { productsQueryKeys } from '@/core/query-keys/products-query-keys';

/** Page size of the product history (design: 20 per "show older"). */
export const PRODUCT_EVENTS_PAGE_SIZE = 20;

/**
 * Product history of the current workspace, newest first, one cursor page
 * per "show older entries" (DEV-755).
 */
export function useProductEvents(
  workspaceId: string | null | undefined,
  productId: string | null | undefined,
) {
  return useInfiniteQuery({
    queryKey: productsQueryKeys.events(workspaceId, productId),
    queryFn: async ({ pageParam }) => {
      if (!workspaceId || !productId) throw new Error('Missing product');
      const res = await ProductsApi.listProductEvents({
        path: { workspaceId, id: productId },
        query: {
          limit: PRODUCT_EVENTS_PAGE_SIZE,
          ...(pageParam ? { cursor: pageParam } : {}),
        },
      });
      return res.data;
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    enabled: !!workspaceId && !!productId,
  });
}
